<template>
    <div>
        <Layout>
            <div v-if="!isLoading" class="col-lg-12">
                <div class="card mb-0" :key="$route.path">
                    <div class="card-body" style="min-height: 100vh">
                        <b-tabs
                            v-model="modelTab"
                            vertical
                            justified
                            nav-class="nav-tabs-custom tabs_landing--page disabled"
                            content-class="p-3 text-muted"
                        >
                            <b-tab v-for="tab in TABS" :key="tab.id" class="border-0" :disabled="tab.disabled">
                                <template v-slot:title>
                                    <span class="">{{ tab.name }}</span>
                                </template>
                                <div>
                                    <SettingBasicLP
                                        v-if="tab.id == 1"
                                        :dataForm.sync="formData"
                                        :configForm="configFormBasicLP"
                                        :listCommon="dataListCommonUse"
                                        :isUpload="isUploadLP"
                                    />
                                    <div v-else class="text-center py-5 text-muted">
                                        <i class="ri-information-line font-size-24 mb-2 d-block text-secondary"></i>
                                        <span>{{
                                            $t('landingPage.upload.needRegisterFirst') ||
                                            '基本設定を登録後、ZIPファイルのアップロードが可能になります。'
                                        }}</span>
                                    </div>
                                    <!-- <SettingDesign v-else-if="tab.id == 2" :dataForm.sync="formData.style_setting" />
                                    <SettingBlocks v-else-if="tab.id == 3" :dataForm="formData" />
                                    <SettingFirstView v-else-if="tab.id == 4" :dataForm.sync="formData.first_view" />
                                    <SettingTimeApplication
                                        v-else-if="tab.id == 5"
                                        :dataForm.sync="formData.application_period"
                                        :configForm="configFormTimeApplication"
                                    />
                                    <SettingPrize
                                        v-else-if="tab.id == 6"
                                        :dataForm.sync="formData.prize_settings"
                                        :masterTypes="masterTypeTitlePrize"
                                        :configForm="configFormPrizeSettings"
                                    />
                                    <SettingTargetProduct
                                        v-else-if="tab.id == 7"
                                        :dataForm.sync="formData.block_target_product"
                                        :configForm="configFormTargetProduct"
                                    />
                                    <SettingApplicationMethod
                                        v-else-if="tab.id == 8"
                                        :dataForm.sync="formData.block_application_method"
                                        :configForm="configFormApplicationMethods"
                                    /> -->
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
                <Footer>
                    <div class="d-flex justify-content-center">
                        <div class="text-center flex-fill">
                            <button type="submit" @click="handleCancel" class="btn btn-common-footer mr-3">{{ $t('btn.cancel') }}</button>
                            <button type="submit" @click="handleSubmit" class="btn btn-common btn-primary">
                                <i class="ri-file-add-line"></i>{{ $t('btn.register') }}
                            </button>
                        </div>
                    </div>
                </Footer>
            </div>
            <div class="d-flex justify-content-center" v-else>
                <LoadingIcon />
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import SettingBasicLP from '../components/setting-basic/main.vue';
// import SettingFirstView from '../components/setting-first_view/main.vue';
// import SettingPrize from '../components/setting-prize/main.vue';
// import SettingTargetProduct from '../components/setting-target_product/main.vue';
// import SettingDesign from '../components/setting-design/main.vue';
// import SettingBlocks from '../components/setting-blocks/main.vue';
// import SettingTimeApplication from '../components/setting-time_application/main.vue';
// import SettingApplicationMethod from '../components/setting-application_method/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import { checkPermission } from '@/utils/handlers';
import { initFormTargetProduct } from './index';
import { TABS, TABS_UPLOAD, initFormRegister } from '../constants';
import { validateAllField } from '@/utils/validate';
import { configFormBasicLP } from '../components/setting-basic/constants';
import { configFormTimeApplication } from '../components/setting-time_application/constants';
import { configFormPrizeSettings } from '../components/setting-prize/constants';
import { configFormTargetProduct } from '../components/setting-target_product/constants';
import { configFormApplicationMethods } from '../components/setting-application_method/constants';
import { masterMethods, landingPageMethods } from '@/state/helpers';
import { handleDataBeforeSaveLP, validateEndDate, validateRangeDate, syncFormDataToConfigFormBasicLP } from '../handlers';
import { showMessage } from '@/utils/messages';

export default {
    name: 'CreateLandingPage',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        SettingBasicLP,
        // SettingFirstView,
        // SettingPrize,
        // SettingTargetProduct,
        // SettingDesign,
        // SettingBlocks,
        // SettingTimeApplication,
        // SettingApplicationMethod,
        LoadingIcon
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('landing_page.register')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        const isUpload = this.$route?.meta?.isUploadLP || this.$route?.query?.type === 'upload' || this.$route?.path?.includes('upload');
        const tabList = isUpload ? TABS_UPLOAD() : TABS();
        const initialForm = initFormRegister();
        initialForm.lp_type = isUpload ? 2 : 1;
        initialForm.type = isUpload ? 2 : 1;
        return {
            isUploadLP: isUpload,
            TABS: tabList.map((tab) => {
                if (tab.id == 1) {
                    tab.disabled = false;
                } else {
                    tab.disabled = true;
                }
                return tab;
            }),
            formData: initialForm,
            formDataTargetProduct: initFormTargetProduct(),
            configFormBasicLP: configFormBasicLP(isUpload),
            configFormTimeApplication: configFormTimeApplication(),
            configFormPrizeSettings: configFormPrizeSettings(),
            configFormTargetProduct: configFormTargetProduct(),
            configFormApplicationMethods: configFormApplicationMethods(),
            dataListCommonUse: {},
            modelTab: 0,
            settingBasicTab: 0,
            masterTypeTitlePrize: [],
            isLoading: false
        };
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...landingPageMethods,

        handleCancel() {
            this.$router.push({
                path: '/landing-page/list'
            });
        },

        async handleSubmit() {
            syncFormDataToConfigFormBasicLP(this.formData, this.configFormBasicLP);
            let checkBasicLP = validateAllField(this.configFormBasicLP);
            let checkStartLPWithStartCP = validateEndDate(
                this.configFormBasicLP['configFieldLPStartDateTime'],
                this.configFormBasicLP['configFieldCampaignStartDateTime']
            );
            let checkStartCPWithEndCP = validateEndDate(
                this.configFormBasicLP['configFieldCampaignStartDateTime'],
                this.configFormBasicLP['configFieldCampaignEndDateTime']
            );
            let checkEndLPWithEndCP = validateEndDate(
                this.configFormBasicLP['configFieldCampaignEndDateTime'],
                this.configFormBasicLP['configFieldLPEndDateTime']
            );
            let checkEndDatePublication = validateEndDate(
                this.configFormBasicLP['configFieldPublicationStartDateTime'],
                this.configFormBasicLP['configFieldPublicationEndDateTime']
            );
            let checkRangePublicationWidthStartLP = validateRangeDate(
                this.configFormBasicLP['configFieldPublicationStartDateTime'],
                this.configFormBasicLP['configFieldPublicationEndDateTime'],
                this.configFormBasicLP['configFieldLPStartDateTime']
            );

            if (
                !checkBasicLP ||
                !checkStartLPWithStartCP ||
                !checkStartCPWithEndCP ||
                !checkEndLPWithEndCP ||
                !checkEndDatePublication ||
                !checkRangePublicationWidthStartLP
            )
                return;
            let payload = handleDataBeforeSaveLP(this.formData);
            payload.lp_type = this.isUploadLP ? 2 : 1;
            payload.type = this.isUploadLP ? 2 : 1;
            this.isLoading = true;
            try {
                const data = await this.registerLandingPage(payload);
                if (data.code !== 200) {
                    showMessage(data.code, this.$bvToast, this.$t(data.message));
                    return;
                }
                // const createdId = data.data?.id;
                this.$router.push({ path: '/landing-page/list' }).then(() => {
                    showMessage(data.code, this.$bvToast, 'LPが登録されました。');
                });
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async getListMaterCommon() {
            try {
                const dataRes = await this.listMaster('campaign/common-campaign-data');
                this.masterTypeTitlePrize = dataRes['event_prize.type'];
            } catch (error) {
                console.log('error', error);
            }
        },

        async getListCommonUse() {
            try {
                const dataRes = await this.listMaster('campaign/common-user');
                this.dataListCommonUse = {
                    listDataMasterSaleEmploy: dataRes['sale'], //2
                    listUserFilterRole: dataRes['admin_and_instructor'], //1,3
                    listCustomerTeam: dataRes['customer_team']
                };
            } catch (error) {
                console.log('error', error);
            }
        },

        initComponentState() {
            const isUpload = this.$route?.meta?.isUploadLP || this.$route?.query?.type === 'upload' || this.$route?.path?.includes('upload');
            const tabList = isUpload ? TABS_UPLOAD() : TABS();
            const initialForm = initFormRegister();
            initialForm.lp_type = isUpload ? 2 : 1;
            initialForm.type = isUpload ? 2 : 1;

            this.isUploadLP = isUpload;
            this.TABS = tabList.map((tab) => {
                if (tab.id == 1) {
                    tab.disabled = false;
                } else {
                    tab.disabled = true;
                }
                return tab;
            });
            this.formData = initialForm;
            this.formDataTargetProduct = initFormTargetProduct();
            this.configFormBasicLP = configFormBasicLP(isUpload);
            syncFormDataToConfigFormBasicLP(this.formData, this.configFormBasicLP);
            this.configFormTimeApplication = configFormTimeApplication();
            this.configFormPrizeSettings = configFormPrizeSettings();
            this.configFormTargetProduct = configFormTargetProduct();
            this.configFormApplicationMethods = configFormApplicationMethods();
            this.modelTab = 0;
            this.settingBasicTab = 0;
        }
    },
    watch: {
        $route: {
            handler(to, from) {
                if (to.path !== from?.path) {
                    this.initComponentState();
                }
            }
        }
    },
    created() {
        this.getListCommonUse();
        this.getListMaterCommon();
    },
    mounted() {}
};
</script>

<style lang="scss"></style>
